import { makeStyles } from '@material-ui/core/styles';
import theme from 'theme';

const useStyles = makeStyles({
  scenarioTitle: {
    font: 'normal normal bold 30px/34px Arial',
    color: '#393A42',
  },
  filters: {
    marginTop: 20,
    display: 'flex',
  },
  tabRoot: {
    flexGrow: 1,
    '& .MuiTabs-indicator': {
      background: 'none',
    },
  },
  search: {
    '& .MuiOutlinedInput-root': {
      background: '#FFF',
      borderRadius: 25,
    },
  },
  tabInactive: {
    padding: 0,
    fontSize: '18px',
    minWidth: 'auto',
  },
  tabActive: {
    fontWeight: 'bold',
    borderBottom: 'none',
  },
  startingTab: {
    '& .MuiTab-wrapper': {
      width: 'auto',
      paddingRight: 16,
      borderRight: '1px solid #393A42',
    },
  },
  endingTab: {
    paddingLeft: 16,
  },
  scenarioContainer: {
    // paddingTop: 40,
    paddingBottom: 40,
    paddingTop: 64,
    [theme.breakpoints.down("md")]: {
      paddingTop: 32
    }
  },
  scenarioCardMedia: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: '100%',
    opacity: '1',
    '&:hover': {
      opacity: '40%',
    },
  },
  scenarioCardActionArea: {
    position: 'relative',
    height: '100%',
  },
  scenarioCard: {
    position: 'relative',
    height: '309px',
    width: '417px',    
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(102, 144, 239, 0.5)',
      mixBlendMode: 'multiply',
    },
    '&:hover': {
      cursor: 'pointer',
    },
    '&:hover:before': {
      background: 'rgba(102, 144, 239, 1)',
    },
  },
  featuredScenarioCard: {
    position: 'relative',
    aspectRatio: "4/3",
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'transparent linear-gradient(rgba(44,49,75,0.2) 100%, rgba(44,49,75,0.1) 80%, #33487800 50%) 0% 0% no-repeat padding-box',
      mixBlendMode: 'multiply',
    },
    '&:hover': {
      cursor: 'pointer',
    },
    '&:hover:before': {
      background: 'rgba(102, 144, 239, 1)',
    },
  },
  scenarioCardContent: {
    width: '100%',
    height: '100%',
    paddingRight: 24,
    backgroundImage: 'linear-gradient(#2C324BBA, #2C324BB5, #33487800)', 

  },
  featureCardTitle: {
    position: 'relative',
    color: '#FFFFFF',
    opacity: 1,
    font: 'normal normal bold 19px/22px Arial',
    paddingLeft: 29,
    paddingRight: 100,
    paddingTop: 29,
  },
  cutCardTitle: {
    position: 'relative',
    color: '#FFFFFF',
    opacity: 1,
    font: 'normal normal bold 19px/22px Arial',
    paddingLeft: 29,
    paddingRight: 31,
    paddingTop: 32,
  },
  cutCardTitleItalics: {
    position: 'relative',
    color: '#FFFFFF',
    opacity: 1,
    font: 'normal normal bold italic 19px/22px Arial',
    paddingLeft: 29,
    paddingRight: 31,
    paddingTop: 32,
    // fontStyle: ''
  },
  cutCardDescription: {
    position: 'relative',
    color: '#FFFFFF',
    opacity: 1,
    font: 'normal normal normal 14px/20px Arial',
    paddingLeft: 29,
    paddingRight: 31,
    paddingTop: 24,
  },
  cutCardDescriptionResponsive: {
    position: 'relative',
    color: '#FFFFFF',
    opacity: 1,
    font: 'normal normal normal 14px/20px  Arial',
    paddingLeft: 29,
    paddingRight: 31,
    paddingTop: 24,
  },
  closeBtn: {
    position: 'relative',
    top: '5px',
    left: '96%',
  },
  scenarioDialog: {
    width: '70%',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 3px #0000003B',
    borderRadius: '8px',
  },
  dialogTitle: {
    font: 'normal normal bold 22px/30px Arial',
  },
  dialogWrapper: {
    padding: '0 30px',
  },
  dialogDescription: {
    font: 'normal normal normal 14px/22px Arial',
    color: '#343434',
    marginTop: '8px',
    marginBottom: '30px',
  },
  dialogContent: {
    // borderBottom: '1px solid #E7E7E7',
  },
  policyList: {
    marginTop: 22,
  },
  policySelect: {
    background: 'transparent',
    borderRadius: 0,
    border: '1px solid #9E9E9E',
    padding: 8,
  },
  policyAccordion: {
    boxShadow: 'none',
  },
  policyAccordionSummary: {
    padding: '0 8px',
    font: 'normal normal normal 14px/16px Arial',
  },
  policyAccordionDetails: {
    padding: '0 8px',
    color: '#343434',
    font: 'normal normal normal 14px/16px Arial',
  },
  dialogActions: {
    padding: 20,
  },
  notDisplayed: {
    display: 'none',
  },
  displayed: {
    display: 'block',  
  },
  blurry: {
    opacity: 0.56,
  },
  notBlurry: {
    opacity: 1,
  },
  cardContainer: {
    zIndex: 999,
    [theme.breakpoints.up('md')]: {
      width: '639px',
      height: '201px'
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      width: '60%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    }
  },
  cardContentContainer: {
    padding: '30px',
    paddingTop: '0px'
  },
  cardContent: {
    font: 'normal normal normal 14px/16px Arial'
  },
  cardGrid: {
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
      bottom: '85px',
      left: '0px'
    },
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: '85px',
      left: '0px'
  },
},  
  root: {
    overflow: 'hidden',
  }
}, { index: 999 });

export default useStyles;
